import React from "react";

const STATUS_STYLE = {
  draft: "bg-muted text-muted-foreground",
  pending: "bg-[hsl(43_70%_90%)] text-[hsl(35_60%_32%)]",
  published: "bg-accent/15 text-accent",
  archived: "bg-destructive/10 text-destructive",
};

export const StatusBadge = ({ node }) => {
  const extra = node.edit_pending ? "edit pending" : node.archive_pending ? "archive pending" : null;
  return (
    <span className="inline-flex items-center gap-1">
      <span className={`text-[11px] px-2 py-0.5 rounded-full font-semibold uppercase tracking-wide ${STATUS_STYLE[node.status] || STATUS_STYLE.draft}`}>
        {node.status}
      </span>
      {extra && <span className="text-[10px] text-[hsl(35_60%_38%)]">· {extra}</span>}
    </span>
  );
};
